import React, { useContext } from 'react';
import RecipesContext from "context/RecipeContext"
import Row from "./Row";
import { 
    removeTag ,
    saveRecipe,
    removeRecipe,
    clearRecipeSet,
} from "common/recipe-helper";
import "../Sidebar.css";
import { updateURLParams } from "common/query-helper"

const Stack = ({
    category,
    tags,
    api
}) => {
    const { 
        tagsSelected, 
        setTagsSelected, 
        addItem,
        setIsFilterRecipes,
        recipes,
        setQueryParams
    } = useContext(RecipesContext.context);

    const handleSelection = (tag, condition,id) => {
        if (condition === "add") {   
            setIsFilterRecipes(true);
            tagsSelected[category].push(
                {
                    name: tag,
                    id: id
                }
            );
            let sorted = tagsSelected[category].sort((a,b) => a.id - b.id);
            let updatedTagSelection = {
                ...tagsSelected,
                [category]: sorted
            }
            setTagsSelected(updatedTagSelection);
            saveRecipe(api, tagsSelected,category, addItem);  
            setQueryParams(updateURLParams(updatedTagSelection));

        } 

        if (condition === "remove") {
            let filtered = removeTag(tagsSelected, category, tag);
            let updatedTagSelection = {
                ...tagsSelected,
                [category]: filtered
            }

            setTagsSelected(updatedTagSelection);
            removeRecipe(recipes,updatedTagSelection);
            clearRecipeSet(updatedTagSelection, recipes, setIsFilterRecipes);// if no tags selected, clear recipe
            setQueryParams(updateURLParams(updatedTagSelection));
        }
    }

return (
    <div className="react-TagStackContainer">
        <div className="react-StackWrapper">
            <div className="react-StackCategory">
                {category}
            </div>
            <div className="react-StackContainer">

                {tags.map((tag, index) => (
                    <Row 
                        category={category}
                        row={tag} 
                        key={index} 
                        handleSelection={handleSelection}
                    />
                ))}
    
            </div>
        </div>
  </div>
    )
}
 
export default Stack;
